import { HvacFormData } from 'src/modules/hvac/types/HvacFormData';
import { createTrigger } from 'src/utils/createTrigger';

export const HVAC_CHANGE = createTrigger<HvacFormData>('HVAC_CHANGE');
export const HVAC_HIDE_ACCURACY_WARNING = createTrigger<void>('HVAC_HIDE_ACCURACY_WARNING');
